import React from 'react';
import { Modal, Button } from 'antd';
import StructuredPhysicalExamFormFull from './StructuredPhysicalExamFormFull';
import { usePhysicalExamLanguage } from '../hooks/usePhysicalExamLanguage';

const PhysicalExamModal = ({
  visible,
  onCancel,
  initialData,
  onSave,
  patientName,
  patientId, // Add patientId prop
  encounterId // Add encounterId prop
}) => {
  const { getTranslatedText } = usePhysicalExamLanguage();

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      width={800}
      title={`${getTranslatedText('Physical Exam')}${patientName ? ': ' + patientName : ''}`}
      footer={[
        <Button key="close" onClick={onCancel}>
          {getTranslatedText('Close')}
        </Button>
      ]}
    >
      <StructuredPhysicalExamFormFull
        patientId={patientId} // Pass patientId down
        encounterId={encounterId} // Pass encounterId down
        initialData={initialData}
        // Update onSuccess to receive data and call original onSave before closing
        onSuccess={(formattedExamData) => {
          if (onSave) {
            onSave(formattedExamData); // Pass HTML data to the original onSave handler
          }
          onCancel(); // Close the modal
        }}
      />
    </Modal>
  );
};

export default PhysicalExamModal;
